import { useMutation, useQueryClient } from '@tanstack/react-query';

import { markFailedRequisitionNonRetryable } from '../common/api/clients/mariapps.api';
import { queries } from '../common/api/queryKeys/queries';

export const useMariAppsMarkNonRetryable = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: markFailedRequisitionNonRetryable,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.mariAppsFailedRequisitions._def });
        },
    });
};
